(() => {
  const legacySelector = '#alpha-product-museum-hero,#alpha-product-museum-preflight,.amp-dialog,.amp-buy-intro,[data-amp-buy-intro],.amp-refinement-carousel,.amp-stage,.amp-canvas,.amp-caption,.amp-trust';
  const legacyAssetSelector = 'style[id^="alpha-product-museum"],link[href*="product-museum"]';
  let cleaning = false;

  const clean = () => {
    if (cleaning || !document.body) return;
    cleaning = true;

    document.body.classList.remove('alpha-product-museum', 'amp-open');
    document.querySelectorAll(legacySelector).forEach((element) => element.remove());
    document.querySelectorAll(legacyAssetSelector).forEach((element) => element.remove());

    cleaning = false;
  };

  const boot = () => {
    clean();

    const observer = new MutationObserver((mutations) => {
      const legacyReturned = document.body?.classList.contains('alpha-product-museum')
        || document.body?.classList.contains('amp-open')
        || document.querySelector(legacySelector)
        || document.querySelector(legacyAssetSelector);

      if (legacyReturned || mutations.some((mutation) => mutation.addedNodes.length)) clean();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    [50, 150, 350, 700, 1400, 2800, 5000].forEach((delay) => setTimeout(clean, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
